const legacyUtcPattern =
  /^(\d+)-(\d+)-(\d+) (\d+):(\d+)(?::(\d+))? UTC$/;

const formatter = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
  timeZoneName: "short",
});

const parseLegacyUtcDate = (value: string): Date | null => {
  const match = value.match(legacyUtcPattern);
  if (!match) return null;

  const [, month, day, year, hours, minutes, seconds = "0"] = match;

  return new Date(
    Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hours),
      Number(minutes),
      Number(seconds)
    )
  );
};

export const formatEvidenceDateTime = (
  value: string | null | undefined,
): string => {
  if (value == null) return "";

  const trimmedValue = value.trim();
  if (!trimmedValue) return "";

  const parsed = new Date(trimmedValue);
  if (!Number.isNaN(parsed.getTime())) {
    return formatter.format(parsed);
  }

  const legacyDate = parseLegacyUtcDate(trimmedValue);
  if (legacyDate) {
    return formatter.format(legacyDate);
  }

  return trimmedValue;
};
